/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

import ControllersGroup from '../../../controllers/ControllersGroup';
import {
  InputLineController,
  SelectController,
  RangeController,
  ChoiceBoxController,
  ButtonLineController,
} from '../../../controllers/Base';

import fontOptions from '../../../utils/controllersUtils/options';

const defaultProps = {
  handle: () => {},
  config: undefined,
  extend: '',
  setExtend: () => {},
  isGlobalFontActive: false,
};

const LabelControllers = ({
  handle = defaultProps.handle,
  config = defaultProps.config,
  extend = defaultProps.extend,
  setExtend = defaultProps.setExtend,
  isGlobalFontActive = defaultProps.isGlobalFontActive,
}) => (
  <>
    <ControllersGroup
      title="Rótulos"
      id="labels"
      extend={extend}
      setExtend={setExtend}
    >
      <ChoiceBoxController
        label="Posicionamento do rótulo"
        handle={handle}
        kWord="LabelPositionControl"
        options={config?.LayoutControl === 'vertical' ? [
          { value: 'before', label: 'Acima', id: 'before' },
          { value: 'after', label: 'Abaixo', id: 'after' },
        ] : [
          { value: 'before', label: 'Esquerda', id: 'before' },
          { value: 'after', label: 'Direita', id: 'after' },
        ]}
        configValue={config?.LabelPositionControl || 'before'}
        fullWidth
      />
      <SelectController
        label="Fonte"
        handle={handle}
        kWord="LabelsFontFamilyControl"
        options={fontOptions}
        configValue={config?.LabelsFontFamilyControl?.value}
        text="Utilizando fonte global"
        disabled={config?.UseGlobalFont !== false && isGlobalFontActive}
        fullWidth
      />
      <InputLineController
        label="Tamanho"
        handle={handle}
        kWord="LabelsFontSizeControl"
        configValue={config?.LabelsFontSizeControl?.value}
        min={1}
        max={30}
        step={1}
        precision={0}
        isNumber
      />
      <ButtonLineController
        handle={handle}
        fontColorVal={config?.LabelColorControl || '#333333'}
        fontColorKWord="LabelColorControl"
      />
      <RangeController
        label="Rotação"
        handle={handle}
        kWord="LabelRotationControl"
        configValue={config?.LabelRotationControl}
        min={-180}
        max={180}
        fullWidth
      />
      <RangeController
        label="Posição horizontal"
        handle={handle}
        kWord="LabelTranslateX"
        configValue={config?.LabelTranslateX}
        min={-500}
        max={500}
        fullWidth
      />
      <RangeController
        label="Posição vertical"
        handle={handle}
        kWord="LabelTranslateY"
        configValue={config?.LabelTranslateY}
        min={-500}
        max={500}
        fullWidth
      />
    </ControllersGroup>
  </>
);

LabelControllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  isGlobalFontActive: PropTypes.bool,
};

export default LabelControllers;
